module.exports = __webpack_public_path__ + "img/16581284_S.e0e3d7d8.png";